import { Button, ClickAwayListener, DialogContentText, Grid, Input, TextField, Checkbox, FormControlLabel, IconButton, Tooltip, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import upload from './../../../../../assets/icons/cloud-computing.png'
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import checked from './../../../../../assets/icons/checked.png'
import { uploadFiles } from '../../../../../fileUploader/FileUploader';
import pending from './../../../../../assets/icons/pending.png'
import './DocumentUpload.css'
import { ToastContainer, toast } from 'react-toastify';

function HomeCookDocumentUpload(props) {

  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');
  const isTouchDevice = useMediaQuery('(hover: none)');
  const [insuranceInfoOpen, setInsuranceInfoOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const handleFullWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFullWidth(event.target.checked);
  };

  const [tableData, setTableData] = useState([
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Selfie with identity document',
      Description: 'Upload a selfie clearly showing your face along with your identity document',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Copy of identity document',
      Description: 'One of: Passport / National ID card / Driving license',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Proof of Caterer public liability insurance',
      Description: 'Valid insurance document showing coverage for catering/public liability',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Copy of personal bank statement',
      Description: 'Bank statement dated within the last 3 months',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Hygiene certificate',
      Description: 'Hygiene certificate',
      File: [],
      Comment: 'comment',
    }
  ]);

  const [obj, setObj] = useState({
    Id: '12233445',
    KycCompanyDetailsId: '',
    Name: '',
    Description: '',
    File: [],
    Comment: 'comment'
  })
  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  })

  const [filesData, setFilesData] = useState([]);
  // const handleImageUpload = (event) => {
  //   const files = event.target.files
  //   console.log(files);
  //   if (files) {

  //     const imagesArray: string[] = []
  //     const remainingSlots = 5 - state.selectedImages.length
  //     const filesToUpload = Array.from(files).slice(0, remainingSlots)
  //     console.log(filesToUpload);
  //     setFilesData(filesToUpload);
  //     tableData[0].File.push(filesToUpload);
  //     props.parentData(tableData)
  //     event.target.value = '';
  //     for (let i = 0; i < filesToUpload.length; i++) {
  //       const file = filesToUpload[i]
  //       const reader = new FileReader()
  //       reader.onloadend = () => {
  //         imagesArray.push(reader.result as string)
  //         if (imagesArray.length === filesToUpload.length) {
  //           const updatedImages = [...state.selectedImages, ...imagesArray]
  //           setState({ selectedImages: updatedImages })
  //         }
  //       }
  //       reader.readAsDataURL(file)
  //     }
  //   }
  // }

  const [companyBankStatementstate, setCompanyBankStatementstate] = useState<ImageUploadState>({
    selectedImages: [],
  })

  // const [filesData, setFilesData] = useState([]);
  // const handleCompanyBankStatementstateUpload = (event) => {
  //   const files = event.target.files

  //   if (files) {

  //     const imagesArray: string[] = []
  //     const remainingSlots = 5 - companyBankStatementstate.selectedImages.length
  //     const filesToUpload = Array.from(files).slice(0, remainingSlots)
  //     console.log(filesToUpload);
  //     setFilesData(filesToUpload);
  //     tableData[1].File.push(filesToUpload);
  //     props.parentData(tableData)
  //     event.target.value = '';
  //     for (let i = 0; i < filesToUpload.length; i++) {
  //       const file = filesToUpload[i]
  //       const reader = new FileReader()
  //       reader.onloadend = () => {
  //         imagesArray.push(reader.result as string)
  //         if (imagesArray.length === filesToUpload.length) {
  //           const updatedImages = [...companyBankStatementstate.selectedImages, ...imagesArray]
  //           setCompanyBankStatementstate({ selectedImages: updatedImages })
  //         }
  //       }
  //       reader.readAsDataURL(file)
  //     }
  //   }
  // }

  const isFileSizeValid = (file, maxSizeInBytes) => {
    if (file && file.size <= maxSizeInBytes) {
      return file;
    }

  };
  const [CompanyInfoFiles, setCompanyInfoFiles] = useState([]);
  // const handleCompanyInfoFileChange = (event) => {
  //   var valid = true;
  //   const files = event.target.files[0]

  //   const maxSizeInBytes = 50 * 1024 * 1024;

  //   if (isFileSizeValid(files, maxSizeInBytes)) {
  //     tableData[0].File.push(files)
  //     props.parentData(tableData)
  //     props.parentData(tableData)
  //     setCompanyInfoFiles([...CompanyInfoFiles, ...event.target.files]);
  //   } else {

  //     valid = false;
  //     toast.error("File size should be less than or equal to 50 MB", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //   }
  // }

  const handleCompanyInfoFileChange = (event) => {
    const file = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(file, maxSizeInBytes)) {

      const updatedTableData = [...tableData];
      updatedTableData[0] = {
        ...updatedTableData[0],
        File: [...updatedTableData[0].File, file]
      };

      setTableData(updatedTableData);

      // ✅ ALWAYS send full object
      props.parentData({
        tableData: updatedTableData,
        kitchenRegistered,
        hygieneCert
      });

      setCompanyInfoFiles(prev => [...prev, file]);

    } else {
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
      });
    }
  };


  const [CompanyBankStatementFiles, setCompanyBankStatementFiles] = useState([]);
  const handleCompanyBankStatementFileChange = (event) => {

    const file = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(file, maxSizeInBytes)) {

      const updatedTableData = [...tableData];
      updatedTableData[1] = {
        ...updatedTableData[1],
        File: [...updatedTableData[1].File, file]
      };

      setTableData(updatedTableData);

      // ✅ ALWAYS send full object
      props.parentData({
        tableData: updatedTableData,
        kitchenRegistered,
        hygieneCert
      });

      setCompanyBankStatementFiles(prev => [...prev, file]);

    } else {

      // alert("File size should be less than or equal to 50 MB.");
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

  };

  const [DirectorIdentityFiles, setDirectorIdentityFiles] = useState([]);
  const handleDirectorIdentityFileChange = (event) => {

    const file = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(file, maxSizeInBytes)) {

      const updatedTableData = [...tableData];
      updatedTableData[2] = {
        ...updatedTableData[2],
        File: [...updatedTableData[2].File, file]
      };

      setTableData(updatedTableData);

      // ✅ ALWAYS send full object
      props.parentData({
        tableData: updatedTableData,
        kitchenRegistered,
        hygieneCert
      });

      setDirectorIdentityFiles(prev => [...prev, file]);

    } else {
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const [DirectorResidenseFiles, setDirectorResidenseFiles] = useState([]);
  const handleDirectorResidenseFileChange = (event) => {

    const file = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(file, maxSizeInBytes)) {

      const updatedTableData = [...tableData];
      updatedTableData[3] = {
        ...updatedTableData[3],
        File: [...updatedTableData[3].File, file]
      };

      setTableData(updatedTableData);

      // ✅ ALWAYS send full object
      props.parentData({
        tableData: updatedTableData,
        kitchenRegistered,
        hygieneCert
      });

      setDirectorResidenseFiles(prev => [...prev, file]);

    } else {
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const [UBOIdentityFiles, setUBOIdentityFiles] = useState([]);
  const [UBOResidenseFiles, setUBOResidenseFiles] = useState([]);

  const handleNameChange = (event) => {
    setObj((prevObj) => ({ ...prevObj, Name: event.target.value }));
  }
  const handleDescriptionChange = (event) => {
    setObj((prevObj) => ({ ...prevObj, Description: event.target.value }));
  }
  const handleCommentChange = (event) => {
    setObj((prevObj) => ({ ...prevObj, Comment: event.target.value }));
  }

  const [documentName, setDocumentName] = useState()
  const [documentDescription, setDocumentDescription] = useState()
  const [documentComment, setDocumentComment] = useState()

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [preview, setPreview] = useState('');

  const handleFileChange = (event) => {
    const files = event.target.files;

    setSelectedFiles([...selectedFiles, ...files]);
  };
  useEffect(() => {

    setObj((prevObj) => ({ ...prevObj, File: selectedFiles }));

  }, [selectedFiles]);
  //file upload end
  console.log(obj)


  const [parent, setParent] = useState(true)
  const onAdd = () => {
    var valid = true;
    if (obj.Name === '' || obj.Description === '' || obj.File.length === 0) {
      valid = false;
      toast.error("Name, Description & File must be inserted", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else {



      const newObj = {
        Id: '12233445',
        KycCompanyDetailsId: obj.KycCompanyDetailsId,
        Name: obj.Name,
        Description: obj.Description,
        File: obj.File,
        Comment: obj.Comment,
      };
      setTableData((prevData) => [...prevData, newObj]);
      props.parentData(tableData)
      setParent(!parent)
      setSelectedFiles([])
      setOpen(false)

    }
  }
  // useEffect(() => {
  //   props.parentData(tableData)
  // }, [parent])
  // console.log(tableData)


  const UploadFile = () => {
    console.log(filesData);

    uploadFiles(tableData[1].File);
  }
  console.log(tableData[0].File)

  const [kitchenRegistered, setKitchenRegistered] = useState(false);
  const [hygieneCert, setHygieneCert] = useState(false);

  const handleHygieneChange = (e) => {
    const checked = e.target.checked;
    setHygieneCert(checked);

    if (!checked) {
      // ✅ Clear hygiene files safely
      setTableData(prev => {
        const updated = [...prev];

        if (updated[4]) {
          updated[4] = {
            ...updated[4],
            File: []
          };
        }

        props.parentData({
          tableData: updated,
          kitchenRegistered,
          hygieneCert
        });
        return updated;
      });

      // optional: also clear local state if you track it separately
      setUBOResidenseFiles([]);
    }
  };

  const handleHygienecertificateFileUpload = (event) => {
    const file = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (!file) return;

    if (isFileSizeValid(file, maxSizeInBytes)) {

      // ✅ ensure index 4 exists
      const updatedTableData = [...tableData];

      if (!updatedTableData[4]) {
        updatedTablData[4] = { File: [] };
      }

      updatedTableData[4].File.push(file);

      props.parentData(updatedTableData);
      setTableData(updatedTableData); // ⚠️ important if using state

      setUBOResidenseFiles(prev => [...prev, file]);

    } else {
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    props.parentData({
      tableData,
      kitchenRegistered,
      hygieneCert
    });
  }, [tableData, kitchenRegistered, hygieneCert]);

  return (
    <>
      <ToastContainer />
      <div className='p-3 '>


        <Dialog

          open={open}
          onClose={handleClose}

        >
          <div className='dialogColor'>
            <Grid className='d-flex justify-content-between'>
              <DialogTitle>
                Add document

              </DialogTitle>
              <DialogActions>
                <Button onClick={handleClose}><CloseIcon /></Button>
              </DialogActions>
            </Grid>
            <DialogContent>
              <Grid xs={12} className='nameTextarea'>
                <TextField fullWidth id="outlined-basic" label="Name" variant="filled"
                  onChange={handleNameChange} />
              </Grid>
              <Grid xs={12} className='pt-3 descriptionText'>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Description"
                  multiline
                  rows={4}
                  // defaultValue="Default Value"
                  variant="filled"
                  onChange={handleDescriptionChange}
                />
              </Grid>
              <Grid xs={12}>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="file-uploader"
                  />

                  <label htmlFor="file-uploader" className='dotted-border'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {selectedFiles.length > 0 && (
                    <div>

                      <ul >
                        {selectedFiles.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </Grid>
              <Grid xs={12} className='pt-3 descriptionText'>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Type comment (optional)"
                  multiline
                  rows={4}
                  // defaultValue="Default Value"
                  variant="filled"
                  onChange={handleCommentChange}
                />
              </Grid>
              <Grid xs={12} className='pt-3'>
                <div className='add-cancel d-flex  justify-content-between'>
                  <button className='buttonWidth'>Cancel</button>
                  <button className='buttonWidth buttonWidthAdd' onClick={onAdd}>Add</button>
                </div>
              </Grid>
            </DialogContent>
          </div>
        </Dialog>
        <Grid xs={12}>
          <div className="home-cook-kyc-form__table-wrapper">
          <table className='documentUpload mt-4' style={{ width: '100%' }}>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Documents</th>

            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Selfie with identity document*</h6>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[0].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>


                  <Input
                    type="file"
                    onChange={handleCompanyInfoFileChange}
                    style={{ display: 'none' }}
                    id="companyInfo-file-uploader"
                  />

                  {tableData[0].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[0].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}
                  <label htmlFor="companyInfo-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>



                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Copy of identity document*</h6>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[1].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleCompanyBankStatementFileChange}
                    style={{ display: 'none' }}
                    id="CompanyBankStatement-file-uploader"
                  />

                  <label htmlFor="CompanyBankStatement-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[1].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[1].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Copy of personal bank statement*</h6>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[3].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }
              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleDirectorResidenseFileChange}
                    style={{ display: 'none' }}
                    id="DirectorResidense-file-uploader"
                  />

                  <label htmlFor="DirectorResidense-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[3].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[3].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6 style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  Proof of Caterer public liability insurance
                  <ClickAwayListener
                    onClickAway={() => {
                      if (isTouchDevice) setInsuranceInfoOpen(false);
                    }}
                  >
                    <span style={{ display: 'inline-flex' }}>
                      <Tooltip
                        arrow
                        placement="top"
                        title="Food and Catering public liability insurance such as Hiscox Food Business and Restaurants, Protectivity, Everywhen Caterers insurance, MarkelUK home chef insurance, Caunceohara home chef insurance"
                        open={isTouchDevice ? insuranceInfoOpen : undefined}
                        disableHoverListener={isTouchDevice}
                        disableFocusListener={isTouchDevice}
                        disableTouchListener={isTouchDevice}
                      >
                        <IconButton
                          size="small"
                          aria-label="Insurance info"
                          sx={{ p: 0, ml: '2px' }}
                          onClick={() => {
                            if (isTouchDevice) setInsuranceInfoOpen(v => !v);
                          }}
                        >
                          <InfoOutlinedIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </ClickAwayListener>
                </h6>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[2].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleDirectorIdentityFileChange}
                    style={{ display: 'none' }}
                    id="DuirectorIdentity-file-uploader"
                  />

                  <label htmlFor="DuirectorIdentity-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[2].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[2].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>

            {/* {tableData.length > 4 && tableData.slice(4).map((data, index) => {
              return (
                <tr key={index}>
                  <td style={{ width: '30%' }}>
                    <h6> {data.Name}</h6>
                    <p className='tableDescription'>{data.Description}</p>
                  </td>
                  <td style={{ width: '30%' }}>
                    <div className='d-flex'>
                      {data.File.length != 0 ? (
                        <>
                          <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                          <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>
                        </>) :
                        <p>Required</p>
                      }

                    </div>

                  </td>
                  <td>
                    <ul className='dotted-border-forfiles d-flex flex-column'>
                      {data.File.map((dt, index) => (
                        <li key={index}>{dt.name}</li>
                      ))}
                    </ul>
                  </td>
                </tr>
              )
            })} */}



          </table>
          </div>
        </Grid>
        {/* <div className='mt-3 d-flex  align-items-center' style={{ gap: "10px" }}>
          <Button variant="contained" className='UploadButton' onClick={handleClickOpen}>+ Add document</Button>
          <span className='additionalText'>Please note that adding additional document can significantly decreases reviewing time.</span>
        </div> */}
        <div className="mt-3 d-flex flex-column" style={{ gap: "8px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={kitchenRegistered}
                onChange={(e) => setKitchenRegistered(e.target.checked)}
              />
            }
            label="I have registered my home kitchen with my local council at least 28 days ago *"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={hygieneCert}
                onChange={handleHygieneChange}
              />
            }
            label="I have a good hygiene certificate (optional) "
          />
          {hygieneCert && (
            <tr>
              <td style={{ width: '30%' }}>
                <h6>Hygiene certificate</h6>
              </td>

              <td style={{ width: '30%' }}>
                {(tableData[4]?.File?.length || 0) > 0 ? (
                  <div className='d-flex'>
                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}>Done</p>
                  </div>
                ) : (
                  <div className='d-flex'>
                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}>Not uploaded</p>
                  </div>
                )}
              </td>

              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleHygienecertificateFileUpload}
                    style={{ display: 'none' }}
                    id="hygiene-file-uploader"
                  />

                  <label htmlFor="hygiene-file-uploader" className='uploadText'>
                    Upload
                    <img
                      src={upload}
                      alt='upload'
                      style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }}
                    />
                  </label>

                  {(tableData[4]?.File?.length || 0) > 0 && (
                    <div>
                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[4].File.map((file, index) => (
                          <li key={index}>{file.name}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          )}
        </div>
      </div>
    </>
  )
}

export default HomeCookDocumentUpload